import { MobileUnitInformationFooter } from './components/MobileUnitInformationFooter';
import { MobileUnitInformationRows } from './components/MobileUnitInformationRows';
import { singleStructures } from '../../../../../constants/singleStructures';
import { faLocationDot } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../../../../../../../scss/_rentalUnitsMobileUnitInfo.scss';

interface MobileUnitInformationProps {
    propertyGuid: string;
    type: string;
    rentalUnitGuids: string[];
    includeOccupied: boolean;
    isReview?: boolean;
}

export const MobileUnitInformation: React.FC<MobileUnitInformationProps> = ({
    propertyGuid,
    type,
    rentalUnitGuids,
    includeOccupied,
    isReview = false,
}) => {
    return (
        <div className='mobileUnitInformation'>
            {rentalUnitGuids?.map((unitGuid, index) => (
                <div
                    className='mobileUnitInformation-items'
                    key={`mobileUnitInformation-items-item-${unitGuid}`}
                >
                    {!singleStructures.includes(type) && (
                        <div className='mobileUnitInformation-unit'>
                            {' '}
                            <FontAwesomeIcon
                                icon={faLocationDot}
                                className='unit-locator'
                            />
                            Unit {index + 1}
                        </div>
                    )}

                    <MobileUnitInformationRows
                        unitGuid={unitGuid}
                        includeOccupied={includeOccupied}
                        isReview={isReview}
                    />
                </div>
            ))}
            <MobileUnitInformationFooter
                propertyGuid={propertyGuid}
                type={type}
            />
        </div>
    );
};
